import { readApiUrl } from 'shared/lib/env';

export const API_BASE_URL = readApiUrl();

export const endpoints = {
  auth: {
    login: '/auth/login',
    forgotPassword: '/auth/forgot-password',
    me: '/auth/me',
  },
  schools: {
    list: '/schools',
    detail: (slug: string) => `/schools/${slug}`,
  },
  courses: {
    list: '/courses',
    detail: (id: string) => `/courses/${id}`,
    modules: (id: string) => `/courses/${id}/modules`,
  },
  lessons: {
    detail: (id: string) => `/lessons/${id}`,
    related: (id: string) => `/lessons/${id}/related`,
  },
  batches: {
    list: '/batches',
    detail: (id: string) => `/batches/${id}`,
  },
  community: {
    channels: '/community/channels',
    threads: (channelId: string) => `/community/channels/${channelId}/threads`,
    thread: (threadId: string) => `/community/threads/${threadId}`,
    messages: (threadId: string) => `/community/threads/${threadId}/messages`,
  },
  dashboard: {
    overview: '/dashboard/overview',
  },
  notifications: {
    list: '/notifications',
  },
  certificates: {
    list: '/certificates',
    verify: (code: string) => `/certificates/verify/${code}`,
  },
  quizzes: {
    detail: (id: string) => `/quizzes/${id}`,
    submit: (id: string) => `/quizzes/${id}/submit`,
  },
  flashcards: {
    deck: (id: string) => `/flashcards/${id}`,
  },
  bookmarks: {
    list: '/bookmarks',
  },
  notes: {
    list: '/notes',
    privateList: '/notes/private',
  },
  calendar: {
    events: '/calendar/events',
  },
  ai: {
    conversations: '/ai/conversations',
    chat: '/ai/chat',
  },
  notesPdf: {
    resolve: '/notes-pdf/resolve',
  },
  admin: {
    users: '/admin/users',
    teachers: '/admin/teachers',
    schools: '/admin/schools',
    schoolUpdate: (id: string) => `/admin/schools/${id}`,
    batches: '/admin/batches',
    analytics: '/admin/analytics/overview',
    payments: '/admin/payments',
    moderation: '/admin/moderation',
  },
} as const;
